import { Controller } from "@hotwired/stimulus"

// UAT 2026-05-12 — Replaces inline `onchange="this.form.requestSubmit()"` which
// CSP blocks (`script-src` nonce does not apply to inline event handler
// attributes per browser security model; only `unsafe-hashes` would allow it,
// which we explicitly avoid).
//
// Usage:
//   <%= form.select :distibox_id, ...,
//         data: { controller: "auto-submit", action: "change->auto-submit#submit" } %>
//
// Auto-registered via the `controllers/index.js` esbuild glob.
export default class extends Controller {
  submit(event) {
    const form = event.target.closest("form")
    if (form && typeof form.requestSubmit === "function") {
      form.requestSubmit()
    } else if (form) {
      form.submit()
    }
  }
}
